import { createNamespacedHelpers } from 'vuex';
import ConciergeItem from '@/components/concierge_item/ConciergeItem.vue';
import Config from '@/config';
import ConciergeDefs from '@/store/concierge/concierge.d';
import IconWork from '@/assets/icons/work.svg';

const { mapState: mapConciergeState, mapActions: mapConciergeActions } =
  createNamespacedHelpers('Concierge');

export default {
  name: 'ConciergeList',
  components: {
    ConciergeItem,
    IconWork
  },
  mounted: function () {
    this.conciergeStore_initializeConciergeList();
  },
  props: {
    tabName: String,
    isTransferModal: Boolean
  },
  computed: {
    ...mapConciergeState({
      viewableConcierges: (state) =>
        // eslint-disable-next-line complexity
        state.conciergeList.filter((concierge) => {
          const { conciergeLevel: level = 0, agentId } = concierge;
          const { conciergeLevel: myLevel, agentId: myId } =
            state.currentConcierge;

          const isAuthorized = level >= 99 && level <= myLevel;
          const excludedAgents = [Config.TabikoBotConciergeId, myId];
          const isExcludedAgent = excludedAgents.includes(agentId);
          const isPickedChat = concierge.channels.length > 0;

          if (isAuthorized && !isExcludedAgent && isPickedChat)
            return concierge;
        })
    })
  },

  watch: {
    viewableConcierges: {
      handler: function (newValue) {
        this.$emit('concierge-list', {
          tabName: this.tabName,
          count: newValue.length
        });
      }
    }
  },

  methods: {
    ...mapConciergeActions({
      conciergeStore_initializeConciergeList:
        ConciergeDefs.actions.initializeConciergeList
    })
  }
};
